import React from 'react'
import { SxProps, Theme, ToggleButton } from '@mui/material'
import { Segmented } from './ExpandGrid.style'

interface MoveReplaceToggleProps {
  // Null when the lines it stands for are partly moved and partly replaced.
  replaced: boolean | null
  onChange: (replace: boolean) => void
  moveLabel: string
  replaceLabel: string
  sx?: SxProps<Theme>
}

// Whether a mooring line at a grown edge moves out with its name and setup, or is replaced by a new line.
const MoveReplaceToggle: React.FC<MoveReplaceToggleProps> = ({ replaced, onChange, moveLabel, replaceLabel, sx }) => (
  <Segmented
    size="small"
    exclusive
    sx={sx}
    value={replaced == null ? null : replaced ? 'replace' : 'move'}
    onChange={(_, value: string | null) => value && onChange(value === 'replace')}
  >
    <ToggleButton value="move">{moveLabel}</ToggleButton>
    <ToggleButton value="replace">{replaceLabel}</ToggleButton>
  </Segmented>
)

export default MoveReplaceToggle
